import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {LigneParametrageFacturation} from "../../../../core/models/facturation/client/ligne-parametrage-facturation";
import {ToolbarPreparingEvent} from "devextreme/ui/data_grid";
import {DxDataGridComponent} from "devextreme-angular";
import {UtilsService} from "../../../../core/utils/utils.service";
import {TypePeriodeFacturationEnum} from "../../../../core/enums/facturation/client/type-periode-facturation-enum";

@Component({
    selector: 'yo-ligne-parametrage-data-grid',
    templateUrl: './ligne-parametrage-data-grid.component.html',
    styleUrls: ['./ligne-parametrage-data-grid.component.scss'],
    standalone: false
})
export class LigneParametrageDataGridComponent implements OnInit, OnDestroy {

    @ViewChild("grid") grid: DxDataGridComponent;

    @Input() lignes: LigneParametrageFacturation[];

    @Output() onEdit: EventEmitter<LigneParametrageFacturation> = new EventEmitter();
    @Output() onSave: EventEmitter<LigneParametrageFacturation[]> = new EventEmitter();
    @Output() onDelete: EventEmitter<LigneParametrageFacturation[]> = new EventEmitter();
    @Output() onFilter: EventEmitter<TypePeriodeFacturationEnum[]> = new EventEmitter();

    periodes = [
      {value: TypePeriodeFacturationEnum.PASSE, text: 'Prix de vente passés'},
      {value: TypePeriodeFacturationEnum.EN_COURS, text: 'Prix de vente en cours'},
      {value: TypePeriodeFacturationEnum.FUTUR, text: 'Prix de vente futurs'},
    ];

    selectedPeriode: TypePeriodeFacturationEnum[] = [];
    constructor(public utilsSvc: UtilsService) {
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }

    onToolbarPreparing($event: ToolbarPreparingEvent) {
        $event.toolbarOptions.items.unshift(
            {
                location: "before",
                template: "beforeTemplate"
            },
            {
                location: "after",
                template: "afterTemplate"
            }
        );
    }

    getSelectedData(): any[] {
        return this.grid.selectedRowKeys;
    }

  onGridOptionChanged(e: any) {
    if (e.fullName?.includes('columns[8].filterValue') || e.fullName?.includes('columns[11].filterValue')) {
      this.selectedPeriode = e.value;
      this.onFilter.emit(this.selectedPeriode);
    }
  }

  calculateFilterExpression(filterValue, selectedFilterOperation, target) {
    return null;
  }

}
